<template>
    <div>
        <div class="p-field p-col-12  p-mt-2" id="text_Footer"
              style="display: flex; flex-wrap: wrap;" v-if="checkShow">
                <div v-if="checkShow" 
                     style="font-weight: bolder; margin-right: 7px;" >
                    จำนวนข้อมูล : 
                </div>
                <div v-for="item in data" :key="item.DataName">
                  <div  v-if="item.textShow != ''"
                        style="font-weight: bolder; 
                              margin-right: 7px;"> 
                    {{item.DataName}}
                    <span style="font-weight: 100;">
                              {{checkTextShow_NoShow(item)}} 
                      </span>
                  </div>
                </div>
                <div  v-if="checkShow" 
                      style="font-weight: bolder;  
                            margin-left: 5px;"> 
                   จำนวน  {{countItem}}  รายการ
                </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "text-footer",
    components: {},
    props:{
        data:{
            type:Array,
        },
        checkShow:{
            type:Boolean,
            default:false,
        },
        countItem:{
            type:String,
            default:"0",
        }
    },
    methods:{
        checkTextShow_NoShow(data){
            if (data.DataName === "ต้องปรับปรุงข้อมูล" || data.DataName === "หัวหน้าครอบครัว") {
                return ""
            }else{
                return data.textShow
            }
        }
    },
}
</script>
<style scoped>
    @media screen and (max-width: 991px) {
        #text_Footer{
        font-size: 1rem;
        }
    }
</style>
